import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import './i18n/i18n';


import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import MobileNav from './components/layout/MobileNav';


import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Analyses from './pages/Analyses';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Settings from './pages/Settings';
import Logout from './pages/Logout';
import NotFound from './pages/NotFound';
import Packages from './pages/Packages';
import Insurance from './pages/Insurance';
import MedicalTeam from './pages/MedicalTeam';
import Reviews from './pages/Reviews';
import AdminDashboard from './pages/admin/Dashboard';
import ManageServices from './pages/admin/ManageServices';
import ManageTeam from './pages/admin/ManageTeam';
import ManageDoctors from './pages/admin/ManageDoctors';
import ManageNurses from './pages/admin/ManageNurses';
import ManageReports from './pages/admin/ManageReports';
import SendNotifications from './pages/admin/SendNotifications';
import InsuranceManagement from './pages/admin/InsuranceManagement';
import ManagePackages from './pages/admin/ManagePackages';
import ManageEvaluations from './pages/admin/ManageEvaluations';
import ManageUsers from './pages/admin/ManageUsers';
import Evaluation from './pages/Evaluation';
import SharedReport from './pages/SharedReport';




import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/routing/PrivateRoute';
import AdminRoute from './components/routing/AdminRoute';

const App = () => {
  return (
    <AuthProvider>
      <div className="app">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="/medical-team" element={<MedicalTeam />} />
            <Route path="/review" element={<Reviews />} />
            <Route path="/evaluation" element={<Evaluation />} />
            <Route path="/shared-report/:token" element={<SharedReport />} />

            { }
            <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/analyses" element={<PrivateRoute><Analyses /></PrivateRoute>} />
            <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />


            <Route path="/admin" element={<AdminRoute allowedRoles={['admin', 'reception', 'administration']}><AdminDashboard /></AdminRoute>} />
            <Route path="/admin/services" element={<AdminRoute allowedRoles={['admin', 'administration']}><ManageServices /></AdminRoute>} />
            <Route path="/admin/team" element={<AdminRoute allowedRoles={['admin', 'administration']}><ManageTeam /></AdminRoute>} />
            <Route path="/admin/doctors" element={<AdminRoute allowedRoles={['admin', 'administration']}><ManageDoctors /></AdminRoute>} />
            <Route path="/admin/nurses" element={<AdminRoute allowedRoles={['admin', 'administration']}><ManageNurses /></AdminRoute>} />
            <Route path="/admin/reports" element={<AdminRoute allowedRoles={['admin', 'reception']}><ManageReports /></AdminRoute>} />
            <Route path="/admin/insurance" element={<AdminRoute allowedRoles={['admin', 'administration']}><InsuranceManagement /></AdminRoute>} />
            <Route path="/admin/packages" element={<AdminRoute allowedRoles={['admin', 'administration']}><ManagePackages /></AdminRoute>} />
            <Route path="/admin/evaluations" element={<AdminRoute><ManageEvaluations /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute allowedRoles={['admin', 'reception']}><ManageUsers /></AdminRoute>} />
            <Route path="/admin/notifications" element={<AdminRoute><SendNotifications /></AdminRoute>} />

            { }
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <MobileNav />
        <Footer />
      </div>
    </AuthProvider>
  );
};

export default App;
